import React from "react";
import Navbar from "../layout/Navbar/Navbar";
import Sidebar from "../layout/Sidebar/SideBar";

const PermissionError = () => {
  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="app_body">
        <h1>Não tenho permissão para acessar esta página</h1>
        <p>Desculpe, você não tem permissão para acessar esta URL.</p>
      </div>
    </>
  );
};

export default PermissionError;
